import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { OpenRoutes } from './open.routes';
import { PrivateRoutes } from './private.routes';
import { RequireAuth } from './require.auth';

const AppRouter = () => (
  <Routes>
    {OpenRoutes.map((item, key) => (
      <Route key={Number(key)} path={item.path} element={<item.component />} />
    ))}
    <Route path="/" element={<RequireAuth />}>
      {PrivateRoutes.map(item => {
        const Component = item.component as unknown as React.ElementType;
        const ComponentCreate = item.componentCreate as unknown as React.ElementType;
        const ComponentShow = item.componentShow as unknown as React.ElementType;
        const ComponentEdit = item.componentEdit as unknown as React.ElementType;

        // Skip routes without a valid component (parent menu items)
        if (!Component) {
          return null;
        }

        return (
          <React.Fragment key={`route-group-${item.path}`}>
            <Route path={item.path} element={<Component />} />
            {ComponentCreate && (
              <Route
                key={`create-${item.path}`}
                path={`${item.path}/create`}
                element={<ComponentCreate />}
              />
            )}
            {ComponentShow && (
              <Route
                key={`show-${item.path}`}
                path={`${item.path}/:itemId`}
                element={<ComponentShow />}
              />
            )}
            {ComponentEdit && (
              <Route
                key={`edit-${item.path}`}
                path={`${item.path}/:itemId/edit`}
                element={<ComponentEdit />}
              />
            )}
          </React.Fragment>
        );
      })}
    </Route>
  </Routes>
);

export default AppRouter;
